// src/components/appointmentSync.js
//
// İş emri kapandığında bağlı randevunun da kapanmasını sağlayan ortak yardımcı.
// v2'de HİÇBİR kod yolu appointments'a durum:'Tamamlandı' yazmıyordu: randevu
// 'Onaylandı'da çakılı kalıyor, teslim tarihi geçince takvimde sonsuza dek
// kırmızı "Geciken" hayalet olarak duruyordu (Faz 1: çizilen 38 randevunun 34'ü).
//
// Bağ iki yoldan kurulabilir: iş emrindeki appointmentId veya randevudaki
// workOrderId. İkisi de taranır, sonuç tekilleştirilir.

import { db } from '../firebase';
import { collection, doc, getDoc, getDocs, query, where, writeBatch } from 'firebase/firestore';
import { normalizeRandevuDurum, KAPANMIS_RANDEVU_DURUMLARI } from './AppointmentConstants';

export const closeLinkedAppointments = async (workOrderId, appointmentId) => {
    const hedefler = new Map();

    if (appointmentId) {
        const directRef = doc(db, 'appointments', appointmentId);
        const snap = await getDoc(directRef);
        if (snap.exists()) hedefler.set(snap.id, { ref: directRef, durum: snap.data().durum });
    }

    if (workOrderId) {
        const linked = await getDocs(
            query(collection(db, 'appointments'), where('workOrderId', '==', workOrderId))
        );
        linked.docs.forEach(d => hedefler.set(d.id, { ref: d.ref, durum: d.data().durum }));
    }

    const guncellenecek = [...hedefler.values()].filter(
        h => !KAPANMIS_RANDEVU_DURUMLARI.includes(normalizeRandevuDurum(h.durum))
    );
    if (guncellenecek.length === 0) return 0;

    const batch = writeBatch(db);
    guncellenecek.forEach(h => batch.update(h.ref, { durum: 'Tamamlandı' }));
    await batch.commit();
    return guncellenecek.length;
};
